// src/modules/app-views/_apps/appmulti/coupons/pages/Init/components/tableColumns/statusColumn.js
import { Tag } from 'antd';
import translateX from 'utils/translateX';
import couponsModuleService from 'modules/app-views/_apps/appmulti/coupons/service';

function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'status',
    title = 'status',
    dataIndex = 'expirationDate',
    width = 130,
    columnProps = {},
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    align: 'center',
    render: (_, r) => {
      const status = couponsModuleService.getDerivedStatus(r);
      const color = couponsModuleService.getStatusColor(status);
      return <Tag color={color}>{translateX(status)}</Tag>;
    },
  };
}

export default statusColumn;
